module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.creative),
      expression: "!!creative"
    }],
    staticClass: "overlay",
    on: {
      "click": _vm.clear
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.vimeoId) ? _c('div', [_c('iframe', {
    attrs: {
      "src": ("https://player.vimeo.com/video/" + _vm.vimeoId + "?autoplay=1&title=0&byline=0&portrait=0"),
      "width": _vm.size.width,
      "height": _vm.size.height,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bb913b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overlay.vue
// module id = 279
// module chunks = 1